import React, { forwardRef } from 'react';
import styled from 'styled-components';
const Container = styled.div `
  p {
    margin: 0;
  }
`;
// eslint-disable-next-line react/display-name
const HtmlField = forwardRef(({ children, className }, ref) => {
    return (React.createElement(Container, { ref: ref, className: className, dangerouslySetInnerHTML: { __html: children } }));
});
export default HtmlField;
